import cn from 'classnames';
import styles from '~/style/aigallery/serviceMode.module.less';
import {serviceMode as data, moduleTitleCn, moduleContentCn} from '~/locals/aigallery/index';
import {NormalBtn} from './components';
import {useQfScreen} from '../comp/utils/hook';
import {useCptDuration} from '~/utils/trackCptDuration/hook';
import {applicationName} from '~/utils/trackCptDuration/constants';

const id = 'serviceMode';
const iconUrl = require('assets/qf/serviceMode/icon.svg').default;
const ServiceMode = () => {
    const {screenWidth: width} = useQfScreen();
    useCptDuration(id, {
        name: `${applicationName}-多种服务模式-停留时长`
    });
    return (
        <div className={styles.container} id={id}>
            <div className={cn(styles.title, `${moduleTitleCn}`)}>{data.title}</div>
            <div className={cn(styles.main, `${moduleContentCn}`)}>
                <div className={styles.left}>
                    <div className={styles['left-title']}>{data.left.title}</div>
                    <div className={styles['left-content']}>{data.left.content}</div>
                    <div className={styles['left-desc-box']}>
                        {data.left.desc.map(item => {
                            return (
                                <div className={styles['left-desc-item']}>
                                    <img className={styles['left-desc-item-img']} src={iconUrl}></img>
                                    <div
                                        className={styles['left-desc-item-title']}
                                        dangerouslySetInnerHTML={{
                                            __html: width > 599 ? item.title : item.title_small
                                        }}
                                    />
                                    <div className={styles['left-desc-item-context']}>{item.context}</div>
                                </div>
                            );
                        })}
                    </div>
                    <div className={styles['left-btns']}>
                        {data.left.btnList.map(ele => {
                            return (
                                <div
                                    onClick={() => {
                                        if (typeof window !== 'undefined') {
                                            window?.open?.(ele.link, '_blank');
                                        }
                                    }}
                                    className={styles['left-btn']}
                                    {...ele.trackInfo}
                                >
                                    <div
                                        data-text={ele.text}
                                        className={styles['left-btn-text']}
                                        dangerouslySetInnerHTML={{
                                            __html: width > 599 ? ele.text : ele.text_small
                                        }}
                                    ></div>
                                </div>
                            );
                        })}
                    </div>
                </div>
                <div className={styles.right}>
                    {data.right.map(item => (
                        <div className={styles['right-item']}>
                            <div className={styles['right-item-left']}>
                                <div className={styles['right-item-title']}>{item.title}</div>
                                <div className={styles['right-item-desc']}>{item.desc}</div>
                            </div>
                            <NormalBtn
                                data={{
                                    link: item.btn.link,
                                    text: item.btn.text,
                                    secondary: true,
                                    className: styles['normal-btn'],
                                    trackInfo: item.btn.trackInfo
                                }}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ServiceMode;
